<template>
  <div :class="$style.root" v-on="$listeners">
    <img :class="$style.bg" :src="bgImg" />
    <Fade>
      <img v-if="!active" :class="$style.mask" :src="bgMask" />
    </Fade>
    <div :class="$style.wordWrapper">
      <div :class="$style.word">
        <slot></slot>
      </div>
      <slot name="after"></slot>
    </div>

    <div :class="$style.answerContainer">
      <Anicss
        v-if="showAnswer"
        appear
        :enter-active-class="['animated', 'bounceIn']"
      >
        <SvgIcon :svg="answerSvg" :size="answerSize" :class="answerClass" />
      </Anicss>
    </div>
  </div>
</template>

<script>
import Fade from '@/components/Animate/Fade'
import SvgIcon from '@/components/SvgIcon'
import Anicss from '@/components/Anicss'

export default {
  components: {
    Fade,
    SvgIcon,
    Anicss,
  },
  props: {
    bgImg: {
      type: String,
    },
    bgMask: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    isAnswer: {
      type: Boolean,
      default: null,
    },
    answerSize: {
      type: Number,
      default: 40,
    },
  },
  computed: {
    showAnswer () {
      return this.isAnswer !== null
    },
    answerSvg () {
      return this.isAnswer
        ? require('!svg-inline-loader?classPrefix!@mdi/svg/svg/check.svg')
        : require('!svg-inline-loader?classPrefix!@mdi/svg/svg/close.svg')
    },
    answerClass () {
      return [this.$style.answer, {
        [this.$style.answer_correct]: this.isAnswer,
      }]
    },
  },
}
</script>

<style lang="scss" module>
.root {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: "one";
  @apply cursor-pointer;
  @apply relative;

  &:active {
    transition: transform .2s;
    transform: scale(0.93);
  }
}

.bg,
.mask,
.wordWrapper {
  grid-area: one;
  @apply w-full;
  @apply h-full;
}

.bg,
.mask {
  @apply object-contain;
  @apply object-center;
}

.mask {
  > svg {
    @apply block;
  }
}

.wordWrapper {
  @apply flex;
  @apply items-center;
  @apply justify-center;
}

.word {
  font-size: 5.5rem;
  @apply leading-none;
  @apply text-center;
}

.answerContainer {
  @apply absolute;
  @apply inset-0;
  transform: translate(2.8rem, 2.4rem);
}

.answer {
  @apply absolute;
  @apply inset-0;
  @apply m-auto;
  @apply fill-current;
  color: #ff0000;
  @apply rounded-full;
  // filter: url(#dropshadow);
}

.answer_correct {
  background-color: #444444a1;
  color: #28ff1e;
}
</style>
